"use client";

import { type AnimationEventHandler, type HTMLAttributes, useEffect, useState } from "react";

export interface PresenceProps extends HTMLAttributes<HTMLDivElement> {
  present: boolean;
  unmountOnExit?: boolean;
  onExitComplete?: () => void;
}

export const Presence = ({ present, unmountOnExit, onExitComplete, ...props }: PresenceProps) => {
  const [mounted, setMounted] = useState(present);

  useEffect(() => {
    if (present) {
      setMounted(true);
    }
  }, [present]);

  const onAnimationEnd: AnimationEventHandler<HTMLDivElement> = (event) => {
    if (!present) {
      setMounted(false);
      onExitComplete?.();
    }
    props.onAnimationEnd?.(event);
  };

  if (!mounted && unmountOnExit) {
    return null;
  }

  return (
    <div
      {...props}
      hidden={!mounted}
      style={{ ...props.style, animationFillMode: !present ? "forwards" : undefined }}
      onAnimationEnd={onAnimationEnd}
      data-state={present ? "visible" : "hidden"}
    />
  );
};
